import { Dispatch } from 'redux';

import {
  apiFetchNotifications,
  apiMarkNotificationsAsDismissed,
  apiMarkNotificationsAsRead,
  apiMarkNotificationsAsViewed,
} from 'api/notification/apiUserNotificationEndpoints';
import { ApiNotification } from 'api/notification/types/ApiNotification';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { sortNotifications } from 'utils/userNotifications';

import {
  FetchNotificationsRequestAction,
  FetchNotificationsSuccessAction,
  MainStoreUserNotificationsAction,
  MarkNotificationsDismissedRequestAction,
  MarkNotificationsDismissedSuccessAction,
  MarkNotificationsReadRequestAction,
  MarkNotificationsReadSuccessAction,
  MarkNotificationsViewedRequestAction,
  MarkNotificationsViewedSuccessAction,
} from './userNotifications';

const fetchNotificationsRequest = (): FetchNotificationsRequestAction => ({
  type: 'NOTIFICATIONS_FETCH_REQUEST',
});

const markNotificationsViewedRequest =
  (): MarkNotificationsViewedRequestAction => ({
    type: 'NOTIFICATIONS_MARK_VIEWED_REQUEST',
  });

const markNotificationsReadRequest =
  (): MarkNotificationsReadRequestAction => ({
    type: 'NOTIFICATIONS_MARK_READ_REQUEST',
  });

const markNotificationsDismissedRequest =
  (): MarkNotificationsDismissedRequestAction => ({
    type: 'NOTIFICATIONS_MARK_DISMISSED_REQUEST',
  });

const markNotificationsViewedSuccess = (
  notifications: (ApiNotification | MappedNotification)[],
): MarkNotificationsViewedSuccessAction => ({
  type: 'NOTIFICATIONS_MARK_VIEWED_SUCCESS',
  notifications,
});

const markNotificationsReadSuccess = (
  notifications: (ApiNotification | MappedNotification)[],
): MarkNotificationsReadSuccessAction => ({
  type: 'NOTIFICATIONS_MARK_READ_SUCCESS',
  notifications,
});

const markNotificationsDismissedSuccess = (
  notifications: (ApiNotification | MappedNotification)[],
): MarkNotificationsDismissedSuccessAction => ({
  type: 'NOTIFICATIONS_MARK_DISMISSED_SUCCESS',
  notifications,
});

const fetchNotificationsSuccess = (
  notifications: (ApiNotification | MappedNotification)[],
): FetchNotificationsSuccessAction => ({
  type: 'NOTIFICATIONS_FETCH_SUCCESS',
  notifications,
});

export const fetchNotifications =
  () => (dispatch: Dispatch<MainStoreUserNotificationsAction>) => {
    dispatch(fetchNotificationsRequest());
    return apiFetchNotifications().then((notifications) => {
      dispatch(fetchNotificationsSuccess(sortNotifications(notifications)));
    });
  };

export const markNotificationsAsViewed =
  (ids: Array<string>) =>
  (dispatch: Dispatch<MainStoreUserNotificationsAction>) => {
    dispatch(markNotificationsViewedRequest());
    return apiMarkNotificationsAsViewed(ids).then((notifications) => {
      dispatch(
        markNotificationsViewedSuccess(sortNotifications(notifications)),
      );
    });
  };

export const markNotificationsAsRead =
  (ids: Array<string>) =>
  (dispatch: Dispatch<MainStoreUserNotificationsAction>) => {
    dispatch(markNotificationsReadRequest());
    return apiMarkNotificationsAsRead(ids).then((notifications) => {
      dispatch(markNotificationsReadSuccess(sortNotifications(notifications)));
    });
  };

export const markNotificationsAsDismissed =
  (ids: Array<string>) =>
  (dispatch: Dispatch<MainStoreUserNotificationsAction>) => {
    dispatch(markNotificationsDismissedRequest());
    return apiMarkNotificationsAsDismissed(ids).then((notifications) => {
      dispatch(
        markNotificationsDismissedSuccess(sortNotifications(notifications)),
      );
    });
  };
